// Feature flags — CRA inlines REACT_APP_* at build time. A flag is ON only when
// the env var is exactly "true"; missing/anything else is OFF, so a new surface
// is invisible until the owner flips it in Amplify. Tests may override via the
// second argument.
export const FF = {
  REFERRAL_FLOW: "REACT_APP_FF_REFERRAL_FLOW",            // master switch (Item #IR)
  REFERRAL_FLOW_QUEUE: "REACT_APP_FF_REFERRAL_FLOW_QUEUE",          // Phase 1
  REFERRAL_FLOW_WORKBENCH: "REACT_APP_FF_REFERRAL_FLOW_WORKBENCH",  // Phase 2
  REFERRAL_FLOW_COST: "REACT_APP_FF_REFERRAL_FLOW_COST",            // Phase 3
  REFERRAL_FLOW_PA: "REACT_APP_FF_REFERRAL_FLOW_PA",                // Phase 4
  REFERRAL_FLOW_APPROVAL: "REACT_APP_FF_REFERRAL_FLOW_APPROVAL",    // Phase 5
  REFERRAL_FLOW_DISPENSE: "REACT_APP_FF_REFERRAL_FLOW_DISPENSE",    // Phase 6
  APPROVAL_SLACK_NUDGE: "REACT_APP_FF_APPROVAL_SLACK_NUDGE",
  PATIENT_SMS: "REACT_APP_FF_PATIENT_SMS",
  PRESCRIBER_PORTAL: "REACT_APP_FF_PRESCRIBER_PORTAL",
  COMMISSION_ENGINE_V2: "REACT_APP_FF_COMMISSION_ENGINE_V2",      // V4 · Commission Engine v2 modal (⚙); off → ⚙ navigates to /commission-structure
  BOOKS_BRIDGE: "REACT_APP_FF_BOOKS_BRIDGE",                        // V6 · VitalBooks manual-upload bridge (/books-bridge); off → redirects to /cash-flow
};

export function isFlagOn(name, env = process.env) {
  return String(env[name] ?? "").trim().toLowerCase() === "true";
}
